import { fetchAuthSession } from '@aws-amplify/auth';
import axios, { AxiosError } from 'axios';

const apiAxios = axios.create({
  validateStatus: (status) => {
    return status === 200 || status === 473;
  },
});

apiAxios.interceptors.request.use(
  async (config) => {
    const session = await fetchAuthSession();
    const accessToken = session.tokens?.accessToken?.toString();
    const poolId = import.meta.env.VITE_POOL_ID;

    if (accessToken) {
      localStorage.setItem('accessToken', accessToken); // just in case it is needed
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }

    if (poolId) {
      config.headers['X-Pool-Id'] = poolId;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

apiAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    if (!error.response) {
      console.error('Network Error:', error.message);
      return Promise.reject('Internal Server Error');
    }
    const { status, data } = error.response;

    if (status === 401) {
      console.warn('Unauthorized: Token expired.');
    }

    if (status === 403) {
      return Promise.reject({
        message: 'Access Denied! You do not have permission.',
      });
    }

    if (status === 404) {
      return Promise.reject({ message: 'Requested resource not found.' });
    }

    if (status >= 500) {
      return Promise.reject({
        message: 'Server Error. Please try again later.',
      });
    }

    return Promise.reject(data || { message: 'An unexpected error occurred.' });
  },
);

export default apiAxios;
